// import axios from "axios";
// import userStateManager from "../AppWriteOAuth/UserStateManager";

// const serverBaseUrl = "https://xeloba.ge/Y2BQDEDHzHua2ls/";
// // const serverBaseUrl = "http://localhost:8000/xelapi/"

// const axiosInstance = axios.create({
//   baseURL: `${serverBaseUrl}`,
//   headers: {
//     "Content-Type": "application/json",
//   },
//   withCredentials: true,
// });

// // CSRF ტოკენის მიღება და დაყენება
// axiosInstance.interceptors.request.use(
//   async (config) => {
//     // მხოლოდ მოდიფიკაციის მოთხოვნებისთვის
//     if (config.method !== 'get' && config.method !== 'options') {
//       try {
//         // CSRF ტოკენის მიღება
//         const { data } = await axios.get(`${serverBaseUrl}csrf-token/`, {
//           withCredentials: true
//         });
//         // CSRF ტოკენის დაყენება ჰედერში
//         config.headers['X-CSRFToken'] = data.csrfToken;
//       } catch (error) {
//         console.error('CSRF token request failed', error);
//       }
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // ტოკენის განახლების დროს მიმდინარე მოთხოვნების ტრეკინგი 
// let isRefreshing = false;
// let failedQueue: { resolve: Function; reject: Function }[] = [];

// const processQueue = (error: any, token: string | null = null) => {
//   failedQueue.forEach(prom => {
//     if (error) {
//       prom.reject(error);
//     } else {
//       prom.resolve(token);
//     }
//   });
  
//   failedQueue = [];
// };

// // 401 შეცდომის დამუშავება
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;
    
//     // თუ შეცდომაა 401 და მოთხოვნა განმეორებითი არაა
//     if (error.response?.status === 401 && !originalRequest._retry) {
//       if (isRefreshing) {
//         // თუ რეფრეში მიმდინარეობს, რიგში ჩავაყენოთ ეს მოთხოვნა
//         return new Promise((resolve, reject) => {
//           failedQueue.push({ resolve, reject });
//         })
//           .then(() => {
//             return axiosInstance(originalRequest);
//           })
//           .catch(err => {
//             return Promise.reject(err);
//           });
//       }

//       originalRequest._retry = true;
//       isRefreshing = true;
      
//       try {
//         // ერთხელ ვცდით ტოკენის განახლებას
//         await axiosInstance.post('token/refresh/');
        
//         // შევასრულოთ რიგში მყოფი მოთხოვნები
//         processQueue(null);
        
//         // განმეორებით გამოვაგზავნოთ ორიგინალი მოთხოვნა
//         return axiosInstance(originalRequest);
//       } catch (refreshError) {
//         // ტოკენის განახლების შეცდომისას გასუფთავება
//         processQueue(refreshError);
        
//         // გამოვიყენოთ UserStateManager-ის clearUser
//         await userStateManager.clearUser();
        
//         // გადავამისამართოთ ავტორიზაციის გვერდზე
//         window.location.href = "/authorization";
        
//         return Promise.reject(refreshError);
//       } finally {
//         isRefreshing = false;
//       }
//     }
    
//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;














import axios from "axios";
import userStateManager from "../AppWriteOAuth/UserStateManager";

const serverBaseUrl = "https://xeloba.ge/Y2BQDEDHzHua2ls/";
// const serverBaseUrl = "http://localhost:8000/xelapi/"

const axiosInstance = axios.create({
  baseURL: `${serverBaseUrl}`,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// CSRF ტოკენის მიღება და დაყენება
axiosInstance.interceptors.request.use(
  async (config) => {
    // მხოლოდ მოდიფიკაციის მოთხოვნებისთვის
    if (config.method !== 'get' && config.method !== 'options') {
      try {
        // CSRF ტოკენის მიღება
        const { data } = await axios.get(`${serverBaseUrl}csrf-token/`, {
          withCredentials: true
        });
        // CSRF ტოკენის დაყენება ჰედერში
        config.headers['X-CSRFToken'] = data.csrfToken;
      } catch (error) {
        console.error('CSRF token request failed', error);
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ტოკენის განახლების დროს მიმდინარე მოთხოვნების ტრეკინგი 
let isRefreshing = false;
let failedQueue: { resolve: Function; reject: Function }[] = [];

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  
  failedQueue = [];
};

// 401 შეცდომის დამუშავება
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // თუ შეცდომაა 401 და მოთხოვნა განმეორებითი არაა
    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        // თუ რეფრეში მიმდინარეობს, რიგში ჩავაყენოთ ეს მოთხოვნა
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(() => {
            return axiosInstance(originalRequest);
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;
      
      try {
        // ერთხელ ვცდით ტოკენის განახლებას
        await axiosInstance.post('token/refresh/');
        
        // შევასრულოთ რიგში მყოფი მოთხოვნები
        processQueue(null);
        
        // განმეორებით გამოვაგზავნოთ ორიგინალი მოთხოვნა
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        // ტოკენის განახლების შეცდომისას გასუფთავება
        processQueue(refreshError);
        
        // გამოვიყენოთ UserStateManager-ის clearUser
        await userStateManager.clearUser();
        
        // გადავამისამართოთ ავტორიზაციის გვერდზე
        window.location.href = "/authorization";
        
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;
